import { createStandardAction } from 'typesafe-actions';

export const setError = createStandardAction('APP/SET_ERROR')<Partial<any>>();

export const setQrInstance = createStandardAction('APP/SET_QR_INSTANCE')<
  Partial<any>
>();
